import React,{ useEffect } from 'react';
import {
	Routes,
	Route,
	useNavigate
} from 'react-router-dom';

import Message from './Message';
import Here from './Here';
import Profile from './Profile';
import Explore from './Explore';
import Notification from './Notification';
import ProfileEditForm from './ProfileEditForm';
import PostCreateForm from './PostCreateForm'; 
import Post from './common/Post'; 
import MessageUser from './common/MessageUser'; 
import Feed from './Feed'; 

export default function Home(){
	let navigate = useNavigate();
	
	useEffect(() => {
		let authToken = sessionStorage.getItem("Auth Token");
		
		if(authToken){
			navigate('/home')
		}
		
		if(!authToken){
			navigate('/')
		}
	}, [])
	
	return(
		<>
				<Routes>
					<Route path='/home' element={<Feed titleHead="Feed"/>} />
					<Route path='/message' element={<Message titleHead="Messages"/>} />
					<Route path='/profile' element={<Profile titleHead="Profile"/>} />
					<Route path='/explore' element={<Explore titleHead="Explore"/>} />
					<Route path='/notification' element={<Notification titleHead="Notifications"/>} />
					<Route path='/editprofile' element={<ProfileEditForm titleHead="Edit Profile"/>} />
					<Route path='/postcreateform' element={<PostCreateForm />} />
					<Route path='/post' element={<Post  titleHead="Meow"/>} />
					<Route path='/MessageUser' element={<MessageUser  titleHead="user"/>} />
				</Routes>
		</>
	);
}